import React from 'react';
import * as cn from 'classnames';
import PropTypes from 'prop-types';

function SocialLink({ className, childClassName, ...props }) {
  return (
    <div
      className={cn('text-center p-3', { [className]: !!className })}
      {...props}
    >
      <a
        rel="noreferrer"
        target="_blank"
        href="https://www.facebook.com/DicksonPaL21"
        title="DicksonPaL21"
        className={cn('social', {
          [childClassName]: !!childClassName,
        })}
      >
        <i className="fa-brands fa-facebook-square fa-2x"></i>
      </a>
      <a
        rel="noreferrer"
        target="_blank"
        href="https://www.linkedin.com/in/dickson-palomeras-50685395/"
        title="dickson-palomeras-50685395"
        className={cn('social', {
          [childClassName]: !!childClassName,
        })}
      >
        <i className="fa-brands fa-linkedin fa-2x"></i>
      </a>
      <a
        rel="noreferrer"
        target="_blank"
        href="https://github.com/DicksonPaL21"
        title="DicksonPaL21"
        className={cn('social', {
          [childClassName]: !!childClassName,
        })}
      >
        <i className="fa-brands fa-github-square fa-2x"></i>
      </a>
    </div>
  );
}

SocialLink.defaultProps = {
  className: '',
  childClassName: '',
};

SocialLink.propTypes = {
  className: PropTypes.string,
  childClassName: PropTypes.string,
};

export default React.memo(SocialLink);
